module.exports = __webpack_public_path__ + "img/xr_shadow.028b1852.jpg";